module.exports = __webpack_public_path__ + "static/img/image_bak.b9a19d2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image_bak.gif
// module id = uRcL
// module chunks = 1